"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTopGuildsLeaderboardResponseToJSON = exports.GetTopGuildsLeaderboardResponseFromJSONTyped = exports.GetTopGuildsLeaderboardResponseFromJSON = void 0;
var _1 = require("./");
function GetTopGuildsLeaderboardResponseFromJSON(json) {
    return GetTopGuildsLeaderboardResponseFromJSONTyped(json, false);
}
exports.GetTopGuildsLeaderboardResponseFromJSON = GetTopGuildsLeaderboardResponseFromJSON;
function GetTopGuildsLeaderboardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'guilds': (json['guilds'].map(_1.TopGuildLeaderboardFromJSON)),
    };
}
exports.GetTopGuildsLeaderboardResponseFromJSONTyped = GetTopGuildsLeaderboardResponseFromJSONTyped;
function GetTopGuildsLeaderboardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'guilds': (value.guilds.map(_1.TopGuildLeaderboardToJSON)),
    };
}
exports.GetTopGuildsLeaderboardResponseToJSON = GetTopGuildsLeaderboardResponseToJSON;
